goog.provide("shadow.js.shim.module$$mui$material$ButtonGroup");
goog.provide("module$shadow_js_shim_module$$mui$material$ButtonGroup");
shadow.js.shim.module$$mui$material$ButtonGroup = shadow.js.nativeProvides["@mui/material/ButtonGroup"] = shadow$bridge("@mui/material/ButtonGroup");
module$shadow_js_shim_module$$mui$material$ButtonGroup.default = shadow.js.shim.module$$mui$material$ButtonGroup;
